import { permissoes, routesNames } from '@/core/constants'
import AcessarAtaItensView from '@/views/pages/ata/acessar/gestao-da-ata/itens/AcessarAtaItensView.vue'
import AcessarAtaInformacoesView from '@/views/pages/ata/acessar/gestao-da-ata/informacoes/AcessarAtaInformacoesView.vue'
import AcessarAtaDocumentosView from '@/views/pages/ata/acessar/gestao-da-ata/documentos/AcessarAtaDocumentosView.vue'
import AcessarAtaAcompanhamentoView from '@/views/pages/ata/acessar/gestao-da-ata/acompanhamento/AcessarAtaAcompanhamentoView.vue'
import AcessarMinhasAdesoesView
	from "@/views/pages/ata/acessar/gestao-da-ata/minhas-adesoes/AcessarMinhasAdesoesView.vue";
import AcessarAtaControleSaldosOrgaoView
	from '@/views/pages/ata/acessar/gestao-da-ata/controle-saldos-orgao/AcessarAtaControleSaldosOrgaoView.vue'
import AcessarAtaPartesEnvolvidasView
	from '@/views/pages/ata/acessar/gestao-da-ata/partes-envolvidas/AcessarAtaPartesEnvolvidasView.vue'

export default [
	{
		name: routesNames.ATA.ATA_ACESSAR_ITENS_VIEW,
		path: 'itens',
		component: AcessarAtaItensView,

		meta: {
			page: {
				title: 'Ata de Registro de Preço',
				subtitle: 'Itens',
			},
		},
	},
	{
		name: routesNames.ATA.ATA_ACESSAR_INFORMACOES_VIEW,
		path: 'informacoes',
		component: AcessarAtaInformacoesView,
		meta: {
			page: {
				title: 'Ata de Registro de Preço',
				subtitle: 'Informações',
			},
		},
	},
	{
		name: routesNames.ATA.ATA_ACESSAR_DOCUMENTOS_VIEW,
		path: 'documentos',
		component: AcessarAtaDocumentosView,
		meta: {
			page: {
				title: 'Ata de Registro de Preço',
				subtitle: 'Documentos',
			},
		},
	},
	{
		name: routesNames.ATA.ATA_ACESSAR_ACOMPANHAMENTO_VIEW,
		path: 'acompanhamento',
		component: AcessarAtaAcompanhamentoView,
		meta: {
			page: {
				title: 'Ata de Registro de Preço',
				subtitle: 'Acompanhamento',
			},
		},
	},
	{
		name: routesNames.ATA.ATA_ACESSAR_PARTES_ENVOLVIDAS_VIEW,
		path: 'partes-envolvidas',
		component: AcessarAtaPartesEnvolvidasView,
		meta: {
			page: {
				title: 'Ata de Registro de Preço',
				subtitle: 'Partes Envolvidas',
			},
			requiresAuth: true,
			authorities: [permissoes.ataParteEnvolvidaListar],
		},
	},
	{
		name: routesNames.ATA.ATA_ACESSAR_MINHAS_ADESOES_VIEW,
		path: 'minhas-adesoes',
		component: AcessarMinhasAdesoesView,
		meta: {
			page: {
				title: 'Ata de Registro de Preço',
				subtitle: 'Adesões',
			},
		},
	},
	{
		name: routesNames.ATA.ATA_ACESSAR_CONTROLE_SALDO_ORGAO_VIEW,
		path: 'controle-saldo-orgao',
		component: AcessarAtaControleSaldosOrgaoView,
		meta: {
			page: {
				title: 'Ata de Registro de Preço',
				subtitle: 'Controle de Saldo - Órgão'
			},
			requiresAuth: true,
			authorities: [permissoes.ataAcompanhamentoSaldo],
		}
	},
]
